import React, { Component } from 'react'

import style from './style.css'
export default class Rating extends Component {
    render() {
        let exp = this.props.exp
        switch (exp) {
            case 1:
                exp = 'one'
                break;
            case 2:
                exp = 'two'
                break;
            case 3:
                exp = 'three'
                break;
            default:
                exp = '0'
                break;
        }

        return (
            <div className={`${style.expfeatured}`}>
                <p>{this.props.label}</p>
                <div className={`${style.balls} ` + style[`${exp}`]}>
                    <div className={`${style.ball}`}></div>
                    <div className={`${style.ball}`}></div>
                    <div className={`${style.ball}`}></div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms/Rating/index.js